import Navbar from '@/lib/components/layout/navbar';
import { Button } from '@/lib/components/ui/button';
import { useAuthModal } from 'modules/auth';
import useUser from 'modules/User/hooks/useUser';
import Image from 'next/image';
import { usePathname } from 'next/navigation';
import React from 'react';
import { MdLogin } from 'react-icons/md';
import usePublicRuntimeConfig from '../hooks/usePublicRuntimeConfig';

type HeaderProps = {
  // TODO
} & React.HTMLAttributes<HTMLDivElement>;

const Header: React.FC<HeaderProps> = ({}) => {
  const pathname = usePathname();
  // const { telegram, twitter } = usePublicRuntimeConfig();
  const { session, toggleModal, signin } = useAuthModal();
  const { siteName } = usePublicRuntimeConfig();
  const { user } = useUser();

  return (
    <Navbar className="py-2">
      <Navbar.Logo className="flex-shrink-0">
        <Image
          className="hidden md:block h-12 w-auto flex-shrink-0"
          src="/logo/logo-wide-circled-orange.png"
          alt={siteName}
          height={60}
          width={240}
        />
        <Image className="block md:hidden h-8 w-auto flex-shrink-0" src="/logo/logo-square-orange.png" alt={siteName} height={32} width={32} />
      </Navbar.Logo>
      <Navbar.Item href="#" onClick={() => signin()} className="md:hidden flex items-center gap-2">
        <MdLogin className="block h-6 w-6 fill-primary" aria-hidden="true" />
        <span>Connexion</span>
      </Navbar.Item>
      <Navbar.Item href="/avantages" active={pathname === '/avantages'}>
        Avantages
      </Navbar.Item>
      <Navbar.Item href="/abonnement" active={pathname === '/abonnement'}>
        Abonnement
      </Navbar.Item>
      <Navbar.Item href="/missions" active={pathname === '/missions'}>
        Missions
      </Navbar.Item>
      <Navbar.Item href="/cvtheque" active={pathname === '/cvtheque'}>
        CVThèque
      </Navbar.Item>
      <Navbar.Item href="/recruiters" active={pathname === '/recruiters'}>
        Recruteurs
      </Navbar.Item>
      <Navbar.Item href="/recruter-recruteur-independant" active={pathname === '/recruter-recruteur-independant'}>
        <div className="relative">
          <span>Espace entreprise</span>
          <span className="absolute -top-[10px] -right-6 bg-gradient-to-r from-primary to-error text-white text-[10px] font-bold px-2 py-0.5 rounded-full animate-pulse uppercase">
            Nouveau
          </span>
        </div>
      </Navbar.Item>
      <Navbar.Floating>
        {!!session ? (
          <>
            {user?.roles?.includes?.('company') ? (
              <Button variant="cta" href="/user/me">
                Mon espace
              </Button>
            ) : (
              <Button variant="cta" href="/my-missions">
                Espace Membre
              </Button>
            )}
          </>
        ) : (
          <>
            <Button variant="cta" onClick={() => toggleModal()}>
              Postule<span className="hidden md:inline"> gratuitement</span>
            </Button>
            <Button className="hidden md:block" variant="link" onClick={() => toggleModal()}>
              Connexion
            </Button>
          </>
        )}
      </Navbar.Floating>
    </Navbar>
  );
};

export default Header;
